import dayjs from 'dayjs';

export const BASE_PERIOD_FILTERS = {
  month: dayjs().format('MM'),
  year: dayjs().format('YYYY'),
  transfer_date: dayjs().date() < 16 ? 1 : 16,
  period: 'monthly'
};
